/*
 * @Descripttion:
 * @version: 商城订单接口
 * @Author: limin
 * @Date: 2021-03-23 17:18:02
 * @LastEditors: limin
 * @LastEditTime: 2021-03-30 20:00:53
 */
import request from '../request'
const path = 'ddh.carlife.mall.order'
const commonPath = 'ddh.carlife.common'
export default {
  
  /**
   * 结算-创建订单号，解决重复创建订单的问题
   */
   getOrderCode(data={}) {
    data.method = `${path}.ordercode.create`
    return request(data)
  },
  /**
   * 结算-创建订单
   */
  create(data={}) {
    data.method = `${path}.create`
    return request(data)
  },
  /**
   * 结算-创建订单
   */
  repay(data={}) {
    data.method = `${path}.pay`
    return request(data)
  },
  /**
   * 加入购物车
   * @param {} data 商品信息
   */
  add(data){
    data.method = `${path}.add`
    return request(data)
  },
   /**
   * 确认收货
   * @param {} id 订单id
   */
  confirm(orderCode){
    let data = {
      orderCode,
      method: `${path}.finish`
    }
    return request(data)
  },
   /**
   * 查询订单详情
   * @param {} orderCode 订单编号
   */
  detail(orderCode){
    let data = {
      orderCode,
      method: `${path}.detail`
    }
    return request(data)
  },
  /**
   * 查询订单列表
   * @param {} data 查询条件
   */
  list(data){
    data.method= `${path}.list`
    return request(data)
  },
   /**
   * 查询订单物流详情
   * @param {} data 查询条件
   */
  logistic(data){
    data.method = `${path}.logistic`;
    return request(data)
  },
   /**
   * 删除订单
   * @param {} address
   */
  remove(id){
    let data = {
      id,
      method: `${path}.delete`
    }
    return request(data);
  },
  /**
   * 微信公众号获取支付权限信息
   */
  getJSConfig(data = {}) {
    data.method = `${commonPath}.wechat.jsconfig`
    return request(data);
  },
  /**
   * 申请退款
   * @param {} orderCode 订单编号
   */
  toRefund(orderCode){
    let data = {
      orderCode,
      method: `${path}.torefund`
    }
    return request(data);
  }
}
